import { render, staticRenderFns } from "./ServiceFeeDes.vue?vue&type=template&id=ef51e068&scoped=true&"
import script from "./ServiceFeeDes.vue?vue&type=script&lang=js&"
export * from "./ServiceFeeDes.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFeeDes.vue?vue&type=style&index=0&id=ef51e068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef51e068",
  null
  
)

export default component.exports